window.addEventListener('load', () => {
  mainLayouts();
  mobileLayout();
  subnavLayout();
});

function subnavLayout() {
  $('.subnav__link').click(function() {
    if (
      $('#sub-nav')
        .find('.fal')
        .is(':visible')
    ) {
      let wrap = $(this).parents('.subnav__wrap');
      wrap.toggleClass('subnav__wrap--active');
      let content = wrap.find('.subnav__list');
      content.slideUp();
    }
  });

  $('.subnav__title').click(function() {
    if (
      $('#sub-nav')
        .find('.fal')
        .is(':visible')
    ) {
      let wrap = $(this).parents('.subnav__wrap');
      let content = wrap.find('.subnav__list');
      wrap.toggleClass('subnav__wrap--active');
      if (wrap.hasClass('subnav__wrap--active')) {
        content.slideDown();
      } else {
        content.slideUp();
      }
    }
  });
}

function mainLayouts() {
  const $localeMenu = $('.language-select');
  const $localeItem = $('.language-select__menu');
  const $footerDropdown = $('.footer-tile-content');

  $footerDropdown.on('click', function() {
    $(this).toggleClass('open');
  });

  $('ul.nav li.dropdown-hover, ul.subnav__list li.dropdown-hover').hover(
    function() {
      $(this)
        .find('.dropdown-menu')
        .fadeIn(250);
    },
    function() {
      $(this)
        .find('.dropdown-menu')
        .stop(true, true)
        .fadeOut(250);
    }
  );

  $localeMenu.hover(
    function() {
      $localeItem.fadeIn(250);
    },
    function() {
      $localeItem.fadeOut(250);
    }
  );

  $localeMenu.on('click', function() {
    let $this = $(this);

    if ($this.find('div[aria-expanded]').attr('aria-expanded') === false) {
      $localeItem.fadeIn(250);
    } else {
      $localeItem.fadeOut(250);
    }
  });

  const $mobileNav = $('.navbar-toggle');
  const $mobileDemoBtn = $('.mobile-demo-btn');

  $mobileNav.on('click', function() {
    if ($bod.hasClass('mobile-nav')) {
      $mobileNav.removeClass('active');
      $bod.removeClass('fixed-nav');
      $bod.removeClass('mobile-nav');
      $mobileDemoBtn.removeClass('hidden');
      $mainNav.removeClass('navbar-fixed-top');
      $bod.css({ overflow: 'scroll' });
    } else {
      $mobileNav.addClass('active');
      $bod.addClass('fixed-nav');
      $bod.addClass('mobile-nav');
      $mainNav.addClass('navbar-fixed-top');
      $mobileDemoBtn.addClass('hidden');
      $bod.css({ overflow: 'hidden' });
    }
  });

  const $callOut = $('.bar--callout-g');
  const $header = $('header');
  const $demoBtn = $('#request-a-demo');
  const $subnavRight = $('#subnavRight');
  const editMode = $subNav.data('iseditable');

  $win.scroll(function() {
    let $userPosition = $callOut.length ? $win.scrollTop() - 500 : $win.scrollTop();
    let hasCallout = $callOut.length ? $win.scrollTop() < 1 : true;
    let headerHeight = $header.height();

    if (!$subNav.length) {
      if ($userPosition <= 0) {
        if (hasCallout) {
          $callOut.length && $callOut.css({ visibility: 'visible', height: '', padding: '' });
          $bod.removeClass('fixed-nav');
          $mainNav.removeClass('navbar-fixed-top');
        }
      } else if ($userPosition > 0) {
        $callOut.length && $callOut.css({ visibility: 'hidden', height: 0, padding: 0 });
        $bod.addClass('fixed-nav');
        $mainNav.addClass('navbar-fixed-top');
      }
    } else {
      if ($userPosition <= headerHeight) {
        if (hasCallout) {
          $callOut.length && $callOut.css({ visibility: 'visible', height: '', padding: '' });
          $bod.removeClass('fixed-subnav');
          $subNav.removeClass('subnav-fixed-top');

          if ($demoBtn.length && !editMode) {
            $demoBtn.removeClass('resized');
            $subnavRight.removeClass('shifted');
            $demoBtn.removeClass('shifted');
          }
        }
      } else if (($userPosition = headerHeight)) {
        $callOut.length && $callOut.css({ visibility: 'hidden', height: 0, padding: 0 });
        $bod.addClass('fixed-subnav');
        $subNav.addClass('subnav-fixed-top');
        if ($demoBtn.length && !editMode) {
          $subnavRight.addClass('shifted');
          $demoBtn.addClass('resized');
          $demoBtn.addClass('shifted');
        }
      }
    }
  });
}

function mobileLayout() {
  const $mobileChat = document.querySelector('.mobile-chat-now');

  if ($mobileChat) {
    $mobileChat.addEventListener('click', function() {
      let setAttempts = 0;
      let today = new Date();
      let time = parseInt(`${today.getHours()}${today.getMinutes()}`);
      let isWeekend = [0, 6].indexOf(today.getDay()) > -1;
      let isOnlineTime = 530 <= time && time <= 1630;
      let interactionId = !isWeekend && isOnlineTime ? 76603 : 76606;
      let loadDrift = function() {
        setAttempts++;

        if (typeof window.drift === 'function' && drift.api) {
          drift.api.startInteraction({
            interactionId
          });
        } else if (setAttempts <= 5) {
          setTimeout(() => {
            loadDrift();
          }, 1000);
        }
      };
    });
  }
}
